var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NewsDetail box_1200 ql-snow"},[_c('div',{staticClass:"Message ql-editor",domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.link)?_c('div',{staticClass:"link"},[_c('i',{staticClass:"el-icon-paperclip"}),_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":""}},[_vm._v("链接："+_vm._s(_vm.link))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }